<!--
  No close button and no backdrop: the banner can only be answered, never dismissed, and the site
  stays usable while the user decides.
-->
<div *ngIf="needsDecision()"
     role="dialog"
     aria-modal="false"
     [attr.aria-label]="'components.cookie_banner.title' | translate"
     class="fixed bottom-0 left-0 right-0 z-50 flex justify-center p-3 bg-card-background border-t border-x-0 border-b-0 border-solid border-border-gray shadow-lg">
  <!--
    Mobile first: stacked by default, side by side from `sm` (640px) up. Nearly every user is on a
    phone, where a row cannot hold the copy and three buttons — `min-w-0` is what lets the text
    column shrink instead of forcing the row wider than the viewport.
  -->
  <div class="flex flex-col gap-3 w-full max-w-4xl sm:flex-row sm:items-center sm:gap-4">
    <div class="flex flex-col gap-1 min-w-0">
      <span class="text-sm font-semibold text-title">{{ 'components.cookie_banner.title' | translate }}</span>
      <!-- The route to the policy is one click away, under "Configurar", rather than a second
           sentence here: this strip has to stay short enough to read on a phone. -->
      <span class="text-xs text-default-gray">{{ 'components.cookie_banner.description' | translate }}</span>
    </div>
    <!--
      Equal prominence is the compliance-relevant part: same component, same colour, same width,
      same order of magnitude of effort. Do not restyle one of these three in isolation.
    -->
    <div class="flex flex-col gap-2 sm:flex-row sm:shrink-0">
      <button mat-raised-button color="accent" class="flex-1" [disabled]="isSaving()" (click)="acceptAll()">
        {{ 'components.cookie_banner.accept_all' | translate }}
      </button>
      <button mat-raised-button color="accent" class="flex-1" [disabled]="isSaving()" (click)="rejectAll()">
        {{ 'components.cookie_banner.reject_all' | translate }}
      </button>
      <button mat-raised-button color="accent" class="flex-1" [disabled]="isSaving()" (click)="configure()">
        {{ 'components.cookie_banner.configure' | translate }}
      </button>
    </div>
  </div>
</div>
